import { CLEAR_CART, GET_CART } from "../../constants/ActionTypes";

const INIT_STATE = {
  lineItems: [],
};

/**
 * cart reducer
 * @param state
 * @param action
 * @returns {{lineItems: *[]}|{lineItems}|{lineItems: ((*&{quantity: *})|*)[]}}
 */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CART: {
      return {
        ...state,
        lineItems: action.payload,
      };
    }
    case CLEAR_CART: {
      return {
        ...state,
        lineItems: [],
      };
    }

    default:
      return state;
  }
};
